import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CourseResource from 'legacy/packages/unit-outline/src/components/_shared/CourseResource';
import { sendToTelemetry, TLTRY_DEFAULTS } from 'legacy/src/utility/telemetry';
import ResourceTypes from 'legacy/packages/unit-outline/src/constants';
import {
  getSignedUnitResource,
  getValidBucketUrl,
} from 'legacy/src/utility/utils';

import SubunitDetail from '../SubunitDetail';

import './UnitPreview.scss';

const clickHandler = (unit, resource, subject) => {
  if (resource.displayName === 'Sample Quiz Questions') {
    const params = {
      unit_number: unit.number,
      unit: unit.title,
      subject_id: subject.initId,
      master_subject_id: subject.masterSubjectId,
    };
    sendToTelemetry(
      Object.assign(
        {
          params,
          event_type: 'download_sample_questions',
          app: 'units',
        },
        TLTRY_DEFAULTS[0],
      ),
    );
  }
};

class UnitPreview extends Component {
  state = {
    unitResourceURL: null,
  };

  componentDidMount() {
    const { unit } = this.props;
    const resources = unit.resources || [];
    const unitResource = resources.filter(
      (r) => r.__typename === ResourceTypes.URL && getValidBucketUrl(r.url),
    )[0];
    if (unitResource) {
      getSignedUnitResource(unitResource.url).then((signedResourceURL) => {
        this.setState({
          unitResourceURL: signedResourceURL,
        });
      });
    }
  }

  render() {
    if (!this.props.expand) {
      return null;
    }

    const { unitResourceURL } = this.state;

    const {
      unit,
      activeSubject,
      userData: { isStudent, isTeacher, adminSubjects },
    } = this.props;
    const { number, subunits, subunitLabel } = unit;
    const resources = unit.resources || [];
    const subUnitTitle = activeSubject.data.isPreApSubject
      ? subunitLabel
      : `Unit ${subunitLabel}`;
    const subjectData = isTeacher
      ? adminSubjects.find((x) => x.masterSubjectId === activeSubject.data.id)
      : activeSubject.data;

    const showResources = isStudent
      ? resources.filter((r) => r.isShareable)
      : resources;

    return (
      <div className="unit-preview">
        {(showResources || []).length > 0 && (
          <div className="unit-resources">
            <span className="unit-resources-title">Unit Resources</span>
            <ul className="resource-list unlist">
              {resources &&
                resources.map((resource) => (
                  <li className="unit-resource" key={resource.id}>
                    <CourseResource
                      resource={resource}
                      unitNumber={number}
                      onClick={() => clickHandler(unit, resource, subjectData)}
                    />
                  </li>
                ))}
            </ul>
          </div>
        )}
        <p className="subunit-label">{subUnitTitle}</p>
        <ul className="subunit-list">
          {(subunits || [])
            .map((subunit) => ({ ...subunit, unitResourceURL }))
            .map((subunit) => (
              <SubunitDetail
                key={`${unit.id}-${subunit.id}`}
                unitItem={unit}
                unitNumber={number}
                subunit={subunit}
              />
            ))}
        </ul>
      </div>
    );
  }
}

UnitPreview.displayName = 'UnitPreview';

UnitPreview.defaultProps = {
  expand: false,
};

UnitPreview.propTypes = {
  unit: PropTypes.object.isRequired,
  expand: PropTypes.bool,
};

export default connect((state) => ({
  userData: state.userData,
  activeSubject: state.subject,
}))(UnitPreview);

export { UnitPreview };
